import React from 'react';
import BookingFlow from '../../components/BookingFlow';

const Booking = () => {
    return <BookingFlow mode="guest" />;
};

export default Booking;
